import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivateRoute from "./private-route";
import { appSlugs, tokenMainKeys } from "../../../utils/constants";
import Sales from "../components/sales";
export const OperationKPIRouteConfig = {
  mainPath: {
    path: "/",
    element: <PrivateRoute />,
    exact: true,
    Element: PrivateRoute,
  },
  mainRoute: "/operations-kpi",
  routes: [
    {
      path: "/",
      Element: Sales,
      element: <Sales />,
      exact: true,
    },
  ],
};

const OperationKPIRoutes = ({
  token = tokenMainKeys.operationKPI,
  slug = appSlugs.operationKPI,
}) => {
  return (
    <Routes>
      <Route
        exact
        path="/"
        element={<PrivateRoute token={token} slug={slug} />}
      >
        <Route path="/" element={<Sales token={token} slug={slug} />} />        
      </Route>
    </Routes>
  );
};

export default OperationKPIRoutes;
